export default __webpack_public_path__ + "static/media/Strangler's Tunic of Shattered Souls.50df74db.jpg";